export const CaseRelationRoleEnum = {
  legal_representative: 'legal_representative',
  shareholder: 'shareholder',
} as const;
export type CaseRelationRoleEnum =
  (typeof CaseRelationRoleEnum)[keyof typeof CaseRelationRoleEnum];
